import { useCallback, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import ExpensesService from '@/services/ExpensesService'

export const useExpenseTagFilter = updateFilters => {
	const { i18n } = useTranslation()
	const [selectedTags, setSelectedTags] = useState([])
	const [tags, setTags] = useState([])
	const [loadingTags, setLoadingTags] = useState(false)

	const loadTags = useCallback(async () => {
		setLoadingTags(true)
		const { data, error } = await ExpensesService.getTags()
		if (error) {
			console.error('Failed to load expense tags:', error)
			Swal.fire(i18n.t('expenses.list.messages.errorTitle'), error, 'error')
			setTags([])
		} else {
			setTags(Array.isArray(data) ? data.filter(Boolean) : [])
		}
		setLoadingTags(false)
	}, [i18n])

	useEffect(() => {
		loadTags()
	}, [loadTags])

	const handleTagFilter = useCallback(async () => {
		if (!tags.length && !loadingTags) {
			await loadTags()
		}

		if (!tags.length) {
			Swal.fire(
				i18n.t('expenses.list.tagFilter.noTagsTitle'),
				i18n.t('expenses.list.tagFilter.noTagsText'),
				'info'
			)
			return
		}

		const tagRows = tags
			.map(tag => {
				const checked = selectedTags.includes(tag) ? 'checked' : ''
				return `
					<label style="display:flex; align-items:center; gap:8px; padding:6px 0; cursor:pointer;">
						<input type="checkbox" value="${tag}" ${checked} />
						<span>${tag}</span>
					</label>
				`
			})
			.join('')

		const result = await Swal.fire({
			title: i18n.t('expenses.list.tagFilter.title'),
			html: `<div style="text-align:left; max-height:260px; overflow:auto; padding:4px 2px;">${tagRows}</div>`,
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonText: i18n.t('expenses.list.tagFilter.apply'),
			denyButtonText: i18n.t('expenses.list.tagFilter.clear'),
			cancelButtonText: i18n.t('expenses.list.tagFilter.close'),
			focusConfirm: false,
			preConfirm: () => {
				const checked = Array.from(document.querySelectorAll('input[type="checkbox"][value]'))
					.filter(input => input.checked)
					.map(input => input.value)
				return checked
			},
		})

		if (result.isDenied) {
			setSelectedTags([])
			updateFilters({ tags: null })
			return
		}

		if (result.isConfirmed) {
			const values = Array.isArray(result.value) ? result.value : []
			console.log(`TCL -> TagFilter.jsx:74 -> useExpenseTagFilter -> values:`, values)
			setSelectedTags(values)
			updateFilters(values.length ? { tags: values } : { tags: null })
		}
	}, [i18n, loadTags, loadingTags, selectedTags, tags, updateFilters])

	return {
		selectedTags,
		handleTagFilter,
		refreshTags: loadTags,
	}
}
